import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Navigate, useParams } from 'react-router-dom'

import { findIdea } from '../ideas'

// Rendert eine Idee aus src/ideas als eigenstaendiges Dokument. srcDoc ohne
// sandbox: das iframe laeuft auf dem Origin des Dashboards, damit
// localStorage dort funktioniert und ein Reload nichts verliert.
export default function IdeaPage() {
  const { slug } = useParams()
  const idea = findIdea(slug)
  const [html, setHtml] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!idea) return undefined
    let active = true
    idea
      .load()
      .then((module) => active && setHtml(module.default))
      .catch(() => active && setFailed(true))
    return () => {
      active = false
    }
  }, [idea])

  if (!idea) return <Navigate to='/' replace />

  return (
    <>
      <Helmet>
        <html lang='de' />
        <title>{idea.title}</title>
        <meta name='robots' content='noindex, nofollow' />
      </Helmet>
      {failed && (
        <div className='flex min-h-screen items-center justify-center p-6 text-center text-gray-600'>
          Die Seite konnte nicht geladen werden. Bitte lade sie neu.
        </div>
      )}
      {html && (
        <iframe
          title={idea.title}
          srcDoc={html}
          allow='clipboard-write'
          className='fixed inset-0 h-full w-full border-0'
        />
      )}
    </>
  )
}
